import {HttpInterceptorFn} from '@angular/common/http';

export const xConfigInterceptorFn: HttpInterceptorFn = (req, next) => {

  const pathExcludes: string[] = [
    "/login",
    "/register",
    "/forgot-password",
    "/validate/password-token",
    "/reset-password",
    "/credit-consultation"
  ];

  if (validatePath(req.url, pathExcludes)) {
    return next(req);
  } else {
    const configStorage = localStorage.getItem("_config");
    const accessToken = localStorage.getItem("_accessToken");
    const xConfig = JSON.parse(configStorage as string);
    const xToken = JSON.parse(accessToken as string);
    if (!xConfig) return next(req);
    if (!xToken) return next(req);
    const authReq = req.clone({
      headers: req.headers
        .set('x-config', `${xConfig}`)
        .set('authorization', `Bearer ${xToken}`)
    });
    return next(authReq);
  }
}

const validatePath = (urlReq: string, pathList: string[]): boolean => {
  return pathList.some(pathItem => urlReq.includes(pathItem));
}
